<template>
    <div class="detailsActive" v-loading="loading">
        <div class="indexContainer">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/admin/index',query:{ languageId: this.$route.query.languageId} }"><i class="iconfont icon-shouye"></i> {{this.base.breadcrumbHome||''}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="this.parentTitle" @click.native="toPages('one')" class="breadcrumbSpan">{{this.parentTitle}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="this.activeTitle" @click.native="toPages('two')" class="breadcrumbSpan">{{this.activeTitle}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="this.linkModuleTitle" class="breadcrumbSpan">{{this.linkModuleTitle}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="activeMain">
                <h2>{{data.title}}</h2>
                <h3>{{data.subtitle}}</h3>
                <p class="author">
                    <span>{{data.releaseTime | dateFormat}}</span>
                    <span>{{data.author}}</span>
                    <span>{{this.base.articleShowCount }}：{{data.showCount}}</span>
                </p>
                <p class="describe">{{data.summary}}</p>
                <div v-html="data.content"></div>
            </div>
            <div class="wx" v-if="data.showQrcode = 1">
                <p>{{this.base.articleNumber }}：{{ data.id }}</p>
                <!-- <img src="@/assets/wx.jpg" alt=""> -->
                <!-- <p>微信扫码直接访问</p> -->
                <div class="qrcode" ref="qrCodeUrl"></div>
            </div>
            <el-row class="share">
                <el-col :xs="24" :sm="14">
                    <span>{{this.base.articleShareTo}}</span>
                    <el-popover
                        placement="top"
                        trigger="hover">
                        <div class="qrcode" ref="qrCodeUrl1"></div>
                        <p style="margin:0">{{this.base.articleScanByWechat}}</p>
                        <p style="margin:0">{{this.base.articleShareToWechat}}</p>
                        <el-button slot="reference"><img src="@/assets/share1.png" alt=""></el-button>
                    </el-popover>
                    <el-button type="text"><img src="@/assets/share2.png" alt="" @click="toQQ"></el-button>
                    <el-button type="text"><img src="@/assets/share3.png" alt="" @click="toWB"></el-button>
                    <el-button type="text"><img src="@/assets/share7.png" alt="" @click="toQQZone"></el-button>
                    <!-- <el-button type="text"><img src="@/assets/share4.png" alt=""></el-button>
                    <el-button type="text"><img src="@/assets/share5.png" alt=""></el-button>
                    <el-button type="text"><img src="@/assets/share6.png" alt=""></el-button> -->
                </el-col>
                <el-col :xs="24" :sm="10"  class="shareLogo hidden-xs-only">
                    <img src="@/assets/share_logo.jpg" alt="">
                </el-col>
            </el-row>
            <el-row class="relevantRecommen">
                <div class="relevantMain">
                    <el-divider class="indexTitle">
                        <div class="indexTitleMain indexBg">
                            <h3>{{this.base.articleRecommendTitle }}</h3>
                        </div>
                    </el-divider>
                    <ul>
                        <li v-for="(item,index) in recommenList" :key="index">
                            <span>{{item.releaseTime | dateFormat}}</span>
                            <a @click="rowClick(item)">{{item.title}}</a>
                        </li>
                    </ul>
                </div>
            </el-row>
        </div>
    </div>
</template>
<script>
import { getDetail, getRecommend,getContent} from '@/api/inner.js';
import { getBreadcrumbs } from '@/common/js/common.js'
import { toQQzone, toQQ, toWeibo } from '@/utils/share.js'
import QRCode from 'qrcodejs2';
export default {
    data(){
        return{
            loading: false,
            activeTitle:"",
            parentTitle:"",
            linkModuleTitle:"",
            data: {},
            recommenList:[],
            nowHref:"",
            getBreadcrumbsArr:[],
            moduleId:'',
            moduleTree:this.$store.getters.moduleTree,
            parentTitleType:'',
            activeTitleType:'',
            linkModulesid:'',
            base:this.$store.getters.base||{}

        }
    },
    created(){
        const id = this.$route.query.id;
        // this.moduleTree = JSON.parse(localStorage.getItem('moduleTree'))
        // this.base = JSON.parse(localStorage.getItem('base'))
        this.getData(id);
        this.getRecommend(id);
    },
    destroyed() {
      localStorage.removeItem('name')
    },
    methods:{
        async getData(id) {
            this.loading = true;
            document.title = '';
            await getDetail(id).then(res => {
                this.loading = false;
                this.data = res.data;
                let content = this.data.content.replace(/width="\d*"/g,"")
                this.data.content = content.replace(/height="\d*"/g,"")
                setTimeout(() => {
                  // document.title = this.data.title + '-' + localStorage.getItem('titleSuffix');
                  document.title = this.data.title + '-' + (this.base.titleSuffix || '');
                }, 100);
                let head = document.getElementsByTagName('head');
                let meta = document.createElement('meta');
                document.querySelector('meta[name="keywords"]').setAttribute('content', this.data.keywords)
                if(localStorage.getItem('description')){
                    document.querySelector('meta[name="description"]').setAttribute('content', localStorage.getItem('description'))
                }else{
                    document.querySelector('meta[name="description"]').setAttribute('content', localStorage.getItem('keywords'))
                }
                head[0].appendChild(meta)
                this.linkModulesid = res.data.linkModules[0].parentId
                this.linkModuleTitle = res.data.linkModules[0].name
                this.writeTitle()
            })
        },
        writeTitle(){
          if (this.$route.query.moduleId) {
            this.moduleId = this.$route.query.moduleId;
          } else {
            this.moduleId = this.linkModulesid;
          }
          this.getBreadcrumbsArr = getBreadcrumbs(this.moduleId, this.moduleTree);
          if (this.getBreadcrumbsArr.length > 0) {
            this.parentTitle = this.getBreadcrumbsArr[0].name;
            this.getContent(this.getBreadcrumbsArr[0].id, this.getBreadcrumbsArr[0].level, 1);
          }
          this.activeTitle = '';
          if (this.getBreadcrumbsArr.length > 1) {
            this.activeTitle = this.getBreadcrumbsArr[1].name;
            this.getContent(this.getBreadcrumbsArr[1].id, this.getBreadcrumbsArr[1].level, 2);
          }
        },
        async getRecommend(id) {
            await getRecommend(id, 5).then(res => {
                this.recommenList = res.data;
            })
        },
        toPages(flag) {
            let id = ''
            let level = ''
            let model = ''
            let type = ''
            if(this.moduleId){
                if(flag === 'one'){
                    id = this.getBreadcrumbsArr[0].id;
                    level = this.parentTitlelevel;
                    type = this.parentTitleType;
                    model = this.getBreadcrumbsArr[0].model;
                }else{
                    id = this.getBreadcrumbsArr[1].id;
                    level = this.getBreadcrumbsArr[1].level;
                    type = this.activeTitleType;
                    model = this.getBreadcrumbsArr[1].model;
                }
            }else{
                id = flag === 'one' ? localStorage.getItem('id') : this.$route.query.modelId;
                level = this.$route.query.level
                type = this.$route.query.type
                model = this.$route.query.model;
            }
            this.$router.push({
                name: 'INNERPAGER',
                query: {
                    model: model,
                    id: id,
                    level: level,
                    type:type,
                    languageId: this.$route.query.languageId
                },
            });

        },
        // 获取单页
        async getContent(id,level,flag) {
            await getContent(id).then(res=> {
                if(flag === 1){
                    if(Number(level) === 2) {
                        if(res.data.childs.length > 0) {
                            this.parentTitleType = 2;
                        }
                    }
                }else{
                    if(Number(level) === 2) {
                        if(res.data.childs.length > 0) {
                            this.activeTitleType = 2;
                        }
                    }
                }
            })
        },
        rowClick(row){
            this.$router.push({
              name: 'ARTICLEDETAIL',
              query: {
                languageId: row.languageId,
                model: this.$route.query.model,
                modelId: this.$route.query.id,
                level: this.$route.query.level,
                type:  row.type,
                id: row.id
              }
            });
        },
        creatQrCode() {
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text:this.nowHref, // 需要转换为二维码的内容
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
            var qrcode = new QRCode(this.$refs.qrCodeUrl1, {
                text:this.nowHref, // 需要转换为二维码的内容
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },
        toWechat() {
          toWechat(this.nowHref, this.data.title)
        },
        toQQ() {
          toQQ(this.nowHref, this.data.title)
        },
        toWB() {
          toWeibo(this.nowHref, this.data.title)
        },
        toQQZone() {
          toQQzone(this.nowHref, this.data.title)
        }
    },
    mounted(){
        this.nowHref = window.location.href;
        this.creatQrCode();
    },
    watch: {
      $route(val) {
        this.getData(this.$route.query.id)
        this.getRecommend(this.$route.query.id)
      },
      moduleTree(val){
        this.writeTitle()
      }
    },
}
</script>
<style lang="less" scoped>

.detailsActive{
    /deep/.el-breadcrumb{
        height: auto;
        margin-bottom: 10px;
        border-bottom: 1px solid #eee;
        color: #333;
        line-height: 26px;
    }
    /deep/.el-breadcrumb__inner{
        color: #333;
        cursor: pointer;
        line-height: 26px;
        display: inline-block;
    }
    /deep/.el-breadcrumb__inner.is-link{
        font-weight: normal!important;
    }

    .breadcrumbSpan /deep/.el-breadcrumb__inner{
        cursor: pointer;
        line-height: 27px;
    }
    .qrcode{
        margin: 0 auto;
        display: inline-block;
        width: 100px;
        overflow: hidden;
    }
    .activeMain{
        box-sizing: border-box;
          font-size: 15px;
          line-height: 22px;
          letter-spacing: 1px;
        h2{
            font-size: 20px;
            line-height: 24px;
        }
        h3{
            font-size: 20px;
            font-weight: normal;
        }
        .author{
            color: #666;
            font-size: 14px;
            span{
                padding: 0 10px;
            }
        }
        div{
            width: 100%;
            overflow: hidden;
            p {
                span{
                    width: 100%;
                    img{
                        width: 100%!important;
                    }
                }
            }
        }
        .describe{
            background: #f7f7f7;
            padding: 15px;
            font-size: 14px;
            color: #333;
            line-height: 24px;
            text-align: left;
        }

    }
    .wx{
        border-top:1px solid #f7f7f7;
        padding:30px 0;
        margin-top:30px;
        width: 100%;
        font-size:14px;
        p{
            margin: 0;
            line-height: 26px;
        }
    }
    .share{
        border-bottom:1px solid #f7f7f7;
        border-top:1px solid #f7f7f7;
        text-align: left;
        span{
            display: inline-block;
            margin: 0;
            float: left;
            line-height: 30px;
            padding: 10px;
        }
        .el-button{
            padding: 10px 0;
            width:30px;
            img{
                width: 100%;
            }
        }
        /deep/.el-popover__reference{
            padding: 0;
            border:none;
        }
    }
    .shareLogo{
        text-align: right;
        img{
            height:80px;
        }
    }
    .relevantRecommen{
        background: #f7f7f7;
        padding: 40px 10px;
        margin:40px 0 20px;
        .relevantMain{
            max-width: 580px;
            width: 100%;
            margin: 0 auto;
            .indexTitle{
                margin: 20px 0;
            }
            .el-divider__text{
                background: #f7f7f7;
            }
        }
        ul{
            margin: 0;
            padding: 0;
            padding-top: 10px;
            li{
                text-align: left;
                line-height: 30px;
                a{
                    color: #333;
                    line-height: 30px;
                    overflow: hidden; /*隐藏*/
                    white-space: nowrap;  /*不换行*/
                    text-overflow: ellipsis;  /* 超出部分省略号 */
                    cursor: pointer;
                    width: 60%;
                    display: inline-block;
                }
                span{
                    float: right;
                    color: #666;
                }
            }
            li:hover{
                a{
                    color: #d11a2e;
                }
            }
        }

    }
    @media only screen and (min-width:768px){
        .share{
            .el-button{
                width:40px;
            }
            span{
                line-height: 30px;
            }
        }
        /deep/.el-breadcrumb{
            height: 30px;
        }

    }

}
</style>



// WEBPACK FOOTER //
// src/components/articleDetail/articleDetail.vue